/* eslint-disable no-unused-vars */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import {
  Grid,
  defaultVirtualizedCellRender,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import {
  Button,
  DatePicker,
  Divider,
  Icon,
  Popconfirm,
  Radio,
  Select,
  Switch,
  message,
} from 'antd'
import {
  getCauseCodeAll,
  getContribCondtition,
  getSolarAvailabilityStatus,
  getSolarCauseCode,
  getSolarContribCondtition,
  getSolarInverterGroup,
  getSolarInverterIdByPlantId,
  getSolarPowerData,
  solarEventDelete,
  solarEventDeleteInverter,
  solarLevel2Validation,
  solarPlantSelection,
  solarPlantWithInverterGroup,
} from 'api/pgads'
import {
  DatePickerContext,
  ErrorContext,
  JcTmpErrorContext,
  SpinContext,
  DataContext,
} from 'context'
import { getApiTargetInfo } from 'core'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Label,
  Title,
} from 'core/screen-util'
import React, {
  useEffect,
  useState,
  useContext,
  useMemo,
  useCallback,
} from 'react'
import { connect } from 'react-redux'
import {
  SolarNercEventIoHeaders,
  SolarPerformanceIoHeaders,
  SolarInverterEventIoHeaders,
  StoragePerformanceIoHeaders,
} from './Headers'
import { formatNumber, rowHeaderRender, hasAccesPermits } from 'core/utils'
import SolarPerformanceDialog from './SolarPerformanceDialog'
import SolarEventDialog, { saveDateformat } from './SolarEventDialog'
import SolarStoragePerformanceDialog from './SolarStoragePerformanceDialog'
import PiaTableInfoAntd from './SolarColorTableInfoAntd'
import DailyGraph from './DailyGraph'
import { unitCodeList } from 'card-data/Card97Antd'
import R from 'ramda'
import SolarInverterEventDialog from './SolarInverterEventDialog'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { getTimeZone } from 'wind2/wind2utils'
import moment from 'moment'
import { getSolarEventTypes } from './solarapi'
import {
  HIDE_SOLAR_INVERTER_DATA,
  SOLAR_ADMIN_POWER_DATA,
  SOLAR_POWER_DATA,
} from '../core/EventActions'
import { getEnvConfig, getPermitActions } from '../core/selectors'
import { getValidPlantList } from './util'

const SolarPowerData = ({ targetInfo, ...props }) => {
  const {
    selectedSolarPlant,
    setSelectedSolarPlant: setPlantSelected,
  } = useContext(DataContext)
  const plantSelected = Array.isArray(selectedSolarPlant)
    ? selectedSolarPlant[0]
    : selectedSolarPlant
  const [plantSelectionData, setPlantSelectionData] = useState([])

  const [performanceData, setPerformanceData] = useState([])

  const [eventData, setEventData] = useState([])
  const [colorGrid, setColorGrid] = useState([])
  const [pieCircleGraph, setPieCircleGraph] = useState([])
  const [dailyData, setDailyData] = useState([])
  const [barGraphData, setBarGraphData] = useState([])
  const [limit, setLimit] = useState(0)
  const [inverterLimit, setInverterLimit] = useState(0)
  const [inverterEventData, setInverterEventData] = useState([])
  const [inverterBarGraph, setInverterBarGraph] = useState([])
  const [level2ValidationErrors, setLevel2ValidationErrors] = useState([])

  const [storagePerformance, setStoragePerformance] = useState([])

  const [performanceRowSelected, setPerformanceRowSelected] = useState([])
  const [
    storagePerformanceRowSelected,
    setstoragePerformanceRowSelected,
  ] = useState([])
  const [eventSelected, setEventSelected] = useState([])
  const [inverterSelected, setInverterSelected] = useState([])

  const [selectedDate, setSelectedDate] = useState(
    moment()
      .subtract(1, 'months')
      .endOf('month')
  )
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const [isRetrived, setIsRetrieved] = useState(false)
  const [showPerformanceDialog, setPerformanceDialog] = useState({})
  const [showStoragePerformanceDialog, setStoragePerformanceDialog] = useState(
    {}
  )
  const [showEventDialog, setEventDialog] = useState({})
  const [showInverterEventDialog, setInverterEventDialog] = useState({})

  const [contribConditionList, setContribConditionList] = useState([])

  const [availableStatus, setAvailableStatus] = useState([])
  const [causecodeList, setCausecodeList] = useState([])
  const [inverterIdBYPlant, setInverterIdByPlant] = useState([])
  const [selectedPerformanceType, setSelectedPerformacnceType] = useState('P') // p  = per  s=storage perf
  const [isLever2Validated, setIslever2Validated] = useState(true)

  const [eventTypes, setEventTypes] = useState([])

  const hasSolarPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: props.actionPermits,
        eventActions: [SOLAR_ADMIN_POWER_DATA],
        matchAny: true,
      }),
    [props.actionPermits]
  )
  const hideSolarInverterData = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits: props.actionPermits,
        eventActions: [HIDE_SOLAR_INVERTER_DATA],
        matchAny: true,
      }),
    [props.actionPermits]
  )

  useEffect(
    _ => {
      getSolarContribCondtition(targetInfo).fork(
        _ => _,
        setContribConditionList
      )
      getSolarEventTypes(targetInfo).fork(_ => _, setEventTypes)

      getSolarAvailabilityStatus(targetInfo).fork(_ => _, setAvailableStatus)

      getSolarCauseCode(targetInfo).fork(
        _ => _,
        data => {
          const matchToSelct = data.map(
            ({ system, subsystem, causecode, description }) => ({
              system,
              component: subsystem,
              causeCode: causecode,
              description,
              unitCode: 'SO',
              unitType: 'SO',
              isOMC: false,
            })
          )
          setCausecodeList(matchToSelct)
        }
      )
      getSolarInverterGroup(targetInfo).fork(setError, setInverterGroupList)
    },
    [setError, targetInfo]
  )
  const [plantList, setPlantList] = useState([])
  const [inverterGroupList, setInverterGroupList] = useState([])
  useEffect(
    _ => {
      // make sort plantName
      // solarPlantWithInverterGroup(targetInfo).fork(setError, data => {
      //   const sd = R.sortBy(R.prop('plantName'), data)
      //   setPlantSelectionData(sd)
      //   if (!plantSelected && sd[0] && sd[0].plantId)
      //     setPlantSelected(sd[0].plantId)
      // })
      solarPlantSelection(targetInfo)({
        year: selectedDate.format('YYYY'),
        month: selectedDate.format('MM'),
      }).fork(setError, data => {
        setPlantList(data)
      })
    },
    [targetInfo, selectedDate, setError, plantSelected]
  )

  useEffect(
    _ => {
      let stoList = []

      stoList = getValidPlantList(plantList, inverterGroupList, [])
      setPlantSelectionData(stoList)
      const isValidPlantSelected = stoList.some(
        d => d.plantId === plantSelected
      )
      if (!isValidPlantSelected && stoList[0] && stoList[0].plantId)
        if (plantSelected !== stoList[0].plantId)
          setPlantSelected([stoList[0].plantId])
    },
    [inverterGroupList, plantList, plantSelected, setPlantSelected]
  )

  useEffect(
    _ => {
      if (plantSelected)
        getSolarInverterIdByPlantId(targetInfo)(plantSelected).fork(
          setError,
          setInverterIdByPlant
        )
    },
    [plantSelected, setError, targetInfo]
  )

  const clearData = _ => {
    setPerformanceData([])
    setEventData([])
    setLevel2ValidationErrors([])
    setIsRetrieved(false)

    setColorGrid([])
    setPieCircleGraph([])
    setLimit(parseFloat([]))
    setDailyData([])
    setBarGraphData([])
    setInverterBarGraph([])
    setInverterEventData([])
    setEventSelected([])
    setIslever2Validated(true)
    setStoragePerformance([])
  }

  const retrieveData = (_, cdate = selectedDate) => {
    if (!plantSelected) {
      message.info('Please, Select Plant')
      return
    }
    setSpinning(true)
    getSolarPowerData(targetInfo)({
      year: cdate.format('YYYY'),
      month: cdate.format('MM'),
      plantid: plantSelected,
    }).fork(setError, data => {
      setSpinning(false)
      setIsRetrieved(true)
      setEventData(data.eventData)
      setColorGrid(data.colorGridData)
      setPieCircleGraph(data.colorGridData)
      setLimit(parseFloat(data.maxMWOutages))
      setDailyData(data.dailyData)
      setBarGraphData(data.barGraphData)
      setInverterBarGraph(data.inverterBarGraphData)
      setInverterEventData(data.inverterEvents)
      setInverterLimit(data.maxInverterOutages)

      let perfData = data.performanceData

      perfData = R.sortBy((a, b) => {
        if ((a.inverterGroupName || '') === 'TOTAL') return 100000
        else {
          return R.toLower((a && a.inverterGroupName) || '').localeCompare(
            R.toLower((b && b.inverterGroupName) || '')
          )
        }
      }, perfData)

      const lever2Validate = perfData.find(d => d.recordid === 'NOT')
      setIslever2Validated(!lever2Validate)
      setLevel2ValidationErrors(data.level2ValidationError)

      setPerformanceData(perfData)
      setTmpError(data.level2ValidationError)
      // if (
      //   data.level2ValidationError.length <= 0 ||
      //   !isErrorContains(data.level2ValidationError)
      // ) {
      //   message.info('Level 2 Validation completed successfully.')
      // }

      const storage = R.sortBy((a, b) => {
        if ((a.storageGroupId || '') === 'TOTAL') return 100000
        else {
          return R.toLower((a && a.storageGroupId) || '').localeCompare(
            R.toLower((b && b.storageGroupId) || '')
          )
        }
      }, data.storagePerformance)

      setStoragePerformance(storage)
    })
  }

  const [isNercEvents, setIsNercEvent] = useState(true)

  useEffect(
    _ => {
      setEventSelected([])
      setInverterSelected([])
    },
    [isNercEvents]
  )

  const EventHeader = useCallback(
    width => SolarNercEventIoHeaders(width, contribConditionList),
    [contribConditionList]
  )
  const SolarInverterEventHeaders = useCallback(
    width => SolarInverterEventIoHeaders(width, contribConditionList),
    [contribConditionList]
  )

  const deleteNercEvent = _ => {
    setSpinning(true)
    solarEventDelete(targetInfo)([eventSelected[0]]).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data saved.')
          retrieveData()
        }
      }
    )
  }

  const deleteInverterEvent = _ => {
    setSpinning(true)
    solarEventDeleteInverter(targetInfo)([inverterSelected[0]]).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data saved.')
          retrieveData()
        }
      }
    )
  }

  const PerformanceHeaderFormater = useMemo(
    _ => {
      return SolarPerformanceIoHeaders([]).map(d => {
        if (d.ident === 'invGroupAvailability') {
          const statusMap = R.compose(
            R.fromPairs,
            R.map(d => [d.availabilityStatusCode, d.availabilityStatusName])
          )(availableStatus)
          return { ...d, ...toSelectionColProps(statusMap) }
        }
        return d
      })
    },
    [availableStatus]
  )

  const StoragePerformanceHeaderFormater = useCallback(
    width => {
      const dt = StoragePerformanceIoHeaders.map(d => {
        if (d.ident === 'storageGroupAvailability') {
          const statusMap = R.compose(
            R.fromPairs,
            R.map(d => [d.availabilityStatusCode, d.availabilityStatusName])
          )(availableStatus)
          return { ...d, ...toSelectionColProps(statusMap) }
        }
        return d
      })

      const finWidth = (width - 30) / dt.length

      return dt.map(m => ({ ...m, width: finWidth }))
    },
    [availableStatus]
  )

  const onLevel2Validation = _ => {
    // if (level2ValidationErrors.length <= 0) {
    //   message.info('No validation Warning/Errors.')
    //   // setTmpError([{}])
    // } else setTmpError(level2ValidationErrors)
    setSpinning(true)
    solarLevel2Validation(targetInfo)({
      year: selectedDate.format('YYYY'),
      month: selectedDate.format('MM'),
      plantid: plantSelected,
    }).fork(setError, tmpError => {
      setSpinning(false)
      setTmpError(tmpError)
      if (!isErrorContains(tmpError)) {
        let msg
        if (tmpError.length <= 0) msg = 'No validation Warning/Errors.'
        message.info('Level 2 Validation completed successfully. ' + msg)
      }
    })
  }

  const isPlantLocked = useMemo(
    _ => {
      const total = (performanceData || []).find(
        s => s.inverterGroupName === 'TOTAL'
      ) || { action: 'U' }
      return total.action === 'L' || total.action === 'l'
    },
    [performanceData]
  )

  const getplantIdandEntityId = _ => {
    const sel = plantSelectionData.find(f => f.plantId === plantSelected)
    return { entityId: sel.entityId, plantId: sel.plantId }
  }

  const updatePerformanceCall = _ => {
    setPerformanceDialog({
      isNew: false,
      visible: true,
      data: performanceRowSelected[0],
    })
  }

  const performanceDoubleClick = props => {
    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        const isTtoal =
          performanceRowSelected[0] &&
          (performanceRowSelected[0].subgroupName === 'TOTAL' ||
            performanceRowSelected[0].inverterGroupName === 'TOTAL')
        if (!isTtoal && !R.isNil(isTtoal))
          !isPlantLocked && updatePerformanceCall()
      },
    })
  }

  const updateStoragePerformanceCall = _ => {
    setStoragePerformanceDialog({
      isNew: false,
      visible: true,
      data: storagePerformance[0],
    })
  }

  const storagePerformanceDoubleClick = props => {
    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        const isTtoal =
          storagePerformanceRowSelected[0] &&
          (storagePerformanceRowSelected[0].storageGroupId === 'TOTAL' ||
            storagePerformanceRowSelected[0].storageGroupId === 'TOTAL')
        if (!isTtoal && !R.isNil(isTtoal))
          !isPlantLocked && updateStoragePerformanceCall()
      },
    })
  }

  const showNercEventUpdateDialog = _ => {
    setEventDialog({
      isNew: false,
      visible: true,
      data: {
        ...eventSelected[0],
        ...getplantIdandEntityId(),
        action: 'U',
        eventtype: 'FO',
      },
    })
  }

  const nercEventDoubleClick = props => {
    return defaultVirtualizedCellRender({
      ...props,
      onDoubleClick: _ => {
        !isPlantLocked && showNercEventUpdateDialog()
      },
    })
  }

  const showInverterEventDilaog = _ => {
    setInverterEventDialog({
      isNew: false,
      visible: true,
      data: {
        ...inverterSelected[0],
        ...getplantIdandEntityId(),
        action: 'U',
        eventtype: 'FO',
      },
    })
  }

  const inverterEventDoubleClick = props => {
    return defaultVirtualizedCellRender({
      ...props,
      // onDoubleClick: _ => {
      //   !isPlantLocked && showInverterEventDilaog()
      // },
    })
  }

  const getSelectedPlantDetails = useMemo(
    _ => {
      return plantSelectionData.find(f => f.plantId === plantSelected) || {}
    },
    [plantSelected, plantSelectionData]
  )

  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '200px 300px auto auto auto',
            gap: '10px',
          }}
        >
          <Title>Solar Data</Title>
          <Select
            showSearch
            value={plantSelected}
            style={{ width: '100%' }}
            onChange={plantId => {
              setPlantSelected([plantId])
              clearData()
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {plantSelectionData.map(({ plantName, plantId }) => (
              <Select.Option key={plantId} value={plantId}>
                {plantName}
              </Select.Option>
            ))}
          </Select>
          <DatePicker.MonthPicker
            allowClear={false}
            style={{ width: '100%' }}
            format="MMMM-YYYY"
            value={selectedDate}
            onChange={d => {
              setSelectedDate(d.endOf('month'))
              clearData()
            }}
          />

          <Button.Group style={{ minWidth: '130px', marginLeft: '10px' }}>
            <Button
              title="Previous Month"
              style={{ marginLeft: '10px' }}
              type="primary"
              onClick={() => {
                clearData()
                const dt = selectedDate
                  .clone()
                  .subtract(1, 'M')
                  .endOf('month')
                setSelectedDate(dt)
                retrieveData({}, dt)
              }}
            >
              <Icon type="left" />
            </Button>

            <Button
              title="Next Month"
              style={{}}
              type="primary"
              onClick={() => {
                clearData()
                const dt = selectedDate
                  .clone()
                  .add(1, 'M')
                  .endOf('month')
                setSelectedDate(dt)
                retrieveData({}, dt)
              }}
            >
              <Icon type="right" />
            </Button>
          </Button.Group>
          <Button
            type="primary"
            onClick={retrieveData}
            icon="database"
            style={{ width: '100%' }}
          >
            Retrieve
          </Button>
        </div>
        <Filler />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
          {isRetrived && (
            <div style={{ display: 'flex' }}>
              <Label>
                <b>Plant Status : </b>
              </Label>
              <Icon
                type={isPlantLocked ? 'lock' : 'unlock'}
                style={{
                  fontSize: '30px',
                }}
                theme="twoTone"
              />
            </div>
          )}
          {!isRetrived && <div />}

          <Button
            style={{
              marginLeft: '10px',
              backgroundColor: isLever2Validated ? '#75e675' : '#F08080',
              color: 'black',
            }}
            onClick={onLevel2Validation}
            disabled={!isRetrived}
          >
            Level 2 Validation
          </Button>
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={200} widthOffset={20}>
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: width - 200 + 'px 200px',
                gap: '10px',
              }}
            >
              <DailyGraph
                inverterLimit={inverterLimit}
                limit={limit}
                date={selectedDate.clone().startOf('month')}
                totalWidth={width - 100 - 200}
                data={isNercEvents ? barGraphData : inverterBarGraph}
                totalHeight={150}
                generationData={dailyData}
                colorGrid={colorGrid}
                pieCircleGraph={pieCircleGraph}
              />
              <div style={{ display: 'grid', gridTemplateColumns: '100px' }}>
                {/* <PieCircleGraph data={pieCircleGraph} /> */}
                <PiaTableInfoAntd data={colorGrid} width={150} />
              </div>
              {/* <div /> */}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '500px 80px 20px 70px 20px 70px auto',
                  gap: '5px',
                  alignContent: 'space-around',
                }}
              >
                <div>
                  <Radio.Group
                    onChange={e => {
                      setSelectedPerformacnceType(e.target.value)
                    }}
                    value={selectedPerformanceType}
                  >
                    <Radio value="P">Performance</Radio>
                    <Radio value="S" disabled={storagePerformance.length <= 0}>
                      Storage Performance
                    </Radio>
                  </Radio.Group>
                </div>
                <div>Legend :</div>
                <div
                  style={{
                    backgroundColor: '#00ff00',
                    border: '0px solid black',
                    textAlign: 'center',
                    fontWeight: '700',
                    height: '70%',
                    alignSelf: 'center',
                  }}
                />
                <div>Actual</div>
                <div
                  style={{
                    backgroundColor: 'blue',
                    border: '0px solid black',
                    textAlign: 'center',
                    fontWeight: '700',
                    color: '#f0f8ff',
                    height: '70%',
                    alignSelf: 'center',
                  }}
                />
                <div>Expected</div>

                <div />
              </div>
              <div
                style={{
                  gap: '5px',
                  display: 'grid',
                  paddingRight: '40px',
                  alignItems: 'baseline',
                  alignContent: 'baseline',
                  gridColumnEnd: 'span 1',
                  justifyContent: 'end',
                }}
              >
                {selectedPerformanceType === 'P' && (
                  // hasSolarPowerDataWritePermission &&
                  <Button
                    style={{ width: '150px', paddingRight: '10px' }}
                    disabled={
                      !(
                        isRetrived &&
                        !isPlantLocked &&
                        performanceRowSelected.length > 0
                      )
                    }
                    onClick={updatePerformanceCall}
                    type="primary"
                  >
                    {hasSolarPowerDataWritePermission
                      ? 'Update Performance'
                      : 'View Performance'}
                  </Button>
                )}

                {selectedPerformanceType === 'S' && (
                  // hasSolarPowerDataWritePermission &&
                  <Button
                    style={{ width: '150px', paddingRight: '10px' }}
                    disabled={
                      !(
                        isRetrived &&
                        !isPlantLocked &&
                        storagePerformanceRowSelected.length > 0
                      )
                    }
                    onClick={updateStoragePerformanceCall}
                    type="primary"
                  >
                    {hasSolarPowerDataWritePermission
                      ? 'Update Performance'
                      : 'View Performance'}
                  </Button>
                )}
              </div>
              {/* <div /> */}
              <div style={{ minHeight: '250px', gridColumnEnd: 'span 2' }}>
                {selectedPerformanceType === 'P' && (
                  <Grid
                    sortEnabled
                    data={performanceData}
                    headers={PerformanceHeaderFormater}
                    altBy={u => u.subgroupName}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: 250 - 20,
                      width: width - 30,

                      cellRender: performanceDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      if (
                        selectedRows[0] &&
                        (selectedRows[0].subgroupName === 'TOTAL' ||
                          selectedRows[0].inverterGroupName === 'TOTAL')
                      )
                        setPerformanceRowSelected([])
                      else setPerformanceRowSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={SolarPerformanceIoHeaders([])}
                  />
                )}
                {selectedPerformanceType === 'S' && (
                  <Grid
                    sortEnabled
                    data={storagePerformance}
                    headers={StoragePerformanceHeaderFormater(width)}
                    altBy={u => u.storageGroupId}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height: 250 - 20,
                      width: width - 30,

                      cellRender: storagePerformanceDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      if (
                        selectedRows[0] &&
                        selectedRows[0].storageGroupId === 'TOTAL'
                      )
                        setstoragePerformanceRowSelected([])
                      else setstoragePerformanceRowSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                    initialSortOptions={StoragePerformanceHeaderFormater(width)}
                  />
                )}
              </div>
              <Divider style={{ gridColumnEnd: 'span 2', margin: '0px' }} />

              <div
                style={{
                  display: 'grid',
                  width: width - 20,
                  gap: '5px',
                  gridTemplateColumns:
                    'max-content auto max-content max-content max-content',
                  gridTemplateRows: 'min-content',
                  // justifyContent: 'end',
                }}
              >
                <Radio.Group
                  onChange={e => {
                    setIsNercEvent(e.target.value === 'N')
                  }}
                  value={isNercEvents ? 'N' : 'T'}
                >
                  <Radio value="N">NERC Events</Radio>
                  {!hideSolarInverterData && (
                    <Radio value="T">Inverter Events</Radio>
                  )}
                </Radio.Group>
                <Filler />
                {isNercEvents && (
                  <React.Fragment>
                    {hasSolarPowerDataWritePermission && (
                      <Button
                        onClick={_ => {
                          setEventDialog({
                            isNew: false,
                            visible: true,
                            data: {
                              isNew: true,
                              visible: true,
                              eventType: 'FO',
                              eventtype: 'FO',
                              ...getplantIdandEntityId(),
                              action: 'A',
                              eventstart: selectedDate
                                .clone()
                                .startOf('month')
                                .format(saveDateformat),
                              eventstartTimeZone: getTimeZone({
                                pzone: getSelectedPlantDetails.timeZone,
                                daylightSavings:
                                  getSelectedPlantDetails.daylightSaving,
                                date: selectedDate
                                  .clone()
                                  .startOf('month')
                                  .format(saveDateformat),
                              }),
                            },
                          })
                        }}
                        disabled={!(isRetrived && !isPlantLocked)}
                        type="primary"
                      >
                        Add Event
                      </Button>
                    )}

                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          eventSelected.length > 0
                        )
                      }
                      onClick={showNercEventUpdateDialog}
                      type="primary"
                    >
                      {hasSolarPowerDataWritePermission
                        ? 'Update Event'
                        : 'View Event'}
                    </Button>
                    {hasSolarPowerDataWritePermission && (
                      <Popconfirm
                        title="Delete the task ?"
                        description="Are you sure to delete this task?"
                        onConfirm={deleteNercEvent}
                        onCancel={_ => _}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          disabled={
                            !(
                              isRetrived &&
                              !isPlantLocked &&
                              eventSelected.length > 0
                            )
                          }
                          type="danger"
                        >
                          Delete Event
                        </Button>
                      </Popconfirm>
                    )}
                  </React.Fragment>
                )}

                {/* {!isNercEvents && (
                  <React.Fragment>
                    <Button
                      disabled={!(isRetrived && !isPlantLocked)}
                      onClick={_ => {
                        setInverterEventDialog({
                          isNew: true,
                          visible: true,
                          data: {
                            ...getplantIdandEntityId(),
                            action: 'A',
                            eventtype: 'FO',
                            eventstart: selectedDate
                              .clone()
                              .startOf('month')
                              .format(saveDateformat),
                            eventstartTimeZone: getTimeZone({
                              pzone: getSelectedPlantDetails.timeZone,
                              daylightSavings:
                                getSelectedPlantDetails.daylightSaving,
                              date: selectedDate
                                .clone()
                                .startOf('month')
                                .format(saveDateformat),
                            }),
                          },
                        })
                      }}
                      type="primary"
                    >
                      Add Event
                    </Button>

                    <Button
                      disabled={
                        !(
                          isRetrived &&
                          !isPlantLocked &&
                          inverterSelected.length > 0
                        )
                      }
                      onClick={showInverterEventDilaog}
                      type="primary"
                    >
                      Update Event
                    </Button>
                    <Popconfirm
                      title="Delete the task ?"
                      description="Are you sure to delete this task?"
                      onConfirm={deleteInverterEvent}
                      onCancel={_ => _}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        disabled={
                          !(
                            isRetrived &&
                            !isPlantLocked &&
                            inverterSelected.length > 0
                          )
                        }
                        type="danger"
                      >
                        Delete Event
                      </Button>
                    </Popconfirm>
                  </React.Fragment>
                )} */}
              </div>
              <div />

              {isNercEvents && (
                <div style={{ width: width }}>
                  <Grid
                    data={eventData}
                    headers={EventHeader(width)}
                    // altBy={u => u.entityId}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height:
                        height - 250 - 150 - 50 - 50 - 50 < 200
                          ? 200
                          : height - 250 - 150 - 50 - 50 - 50,
                      width: width,
                      headerRowHeight: 30,
                      cellRender: nercEventDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      setEventSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                  />
                </div>
              )}

              {!isNercEvents && (
                <div style={{ height: 300 - 20 }}>
                  <Grid
                    data={inverterEventData}
                    headers={SolarInverterEventHeaders(width - 30)}
                    // altBy={u => u.entityId}
                    altBgColor="#ebebeb"
                    // onEditInfoChange={info => editRow(info)}
                    // editInfo={editInfo}
                    render={virtualizedGridRenderer({
                      autoFixColByKey: false,
                      rowHeaderRender,
                      height:
                        height - 250 - 150 - 50 - 50 - 50 < 200
                          ? 200
                          : height - 250 - 150 - 50 - 50 - 50,
                      width: width - 30,
                      headerRowHeight: 30,
                      cellRender: inverterEventDoubleClick,
                    })}
                    //   fuzzyFilter={fuzzyFilter}
                    isEditable={false}
                    onSelectionChange={({ selectedRows }) => {
                      setInverterSelected(selectedRows)
                    }}
                    selectionMode="single"
                    selectionType="row"
                  />
                </div>
              )}
            </div>
          </Content>
        )}
      </FullHeightSizer>
      {showPerformanceDialog.visible && (
        <SolarPerformanceDialog
          {...showPerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setPerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          availableStatus={availableStatus}
          setTmpError={setTmpError}
        />
      )}
      {showStoragePerformanceDialog.visible && (
        <SolarStoragePerformanceDialog
          {...showStoragePerformanceDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setStoragePerformanceDialog({})
          }}
          onRetrieve={retrieveData}
          availableStatus={availableStatus}
          setTmpError={setTmpError}
        />
      )}
      {showEventDialog.visible && (
        <SolarEventDialog
          {...showEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setEventDialog({})
          }}
          onRetrieve={retrieveData}
          unitCodeMap={['SO']}
          contribConditionList={contribConditionList}
          causeCodeList={causecodeList}
          selectedPlantDetails={getSelectedPlantDetails}
          selectedDate={selectedDate.clone().startOf('month')}
          eventTypes={eventTypes}
        />
      )}
      {showInverterEventDialog.visible && (
        <SolarInverterEventDialog
          {...showInverterEventDialog}
          targetInfo={targetInfo}
          onHide={_ => {
            setInverterEventDialog({})
          }}
          onRetrieve={retrieveData}
          unitCodeMap={['SO']}
          contribConditionList={contribConditionList}
          causeCodeList={causecodeList}
          selectedPlantDetails={getSelectedPlantDetails}
          inverterIdBYPlant={inverterIdBYPlant}
          selectedDate={selectedDate.clone().startOf('d')}
          eventTypes={eventTypes}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
})
export default connect(mapStateToProps)(SolarPowerData)
